import Vue from 'vue'
import Vuex from 'vuex'
import home from './modules/home'
import getters from './getter'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    home
  },
  getters
})
